/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  let $WindowHeight = window.outerHeight;
  function appHeight() {
    var wh = $(window).innerHeight();
    document.documentElement.style.setProperty("--app-height", wh + "px");
  }
  window.addEventListener("resize", appHeight);
  appHeight();

  $(document).on("click", ".nav-toggle", function (e) {
    $(".nav-toggle").toggleClass("on");
    $("html").toggleClass("nav-open");
  });

  $(".header-menu >  li .submenu-toggle").on("click", function (e) {
    e.preventDefault();
    $(".submenu-toggle")
      .not(this)
      .removeClass("on")
      .siblings(".sub-menu")
      .slideUp();
    //  $(this).closest("li").toggleClass("active");
    $(this).siblings("ul.sub-menu").slideToggle();
    $(this).toggleClass("on");
  });

  window.addEventListener("scroll", function (e) {
    var top = this.scrollY;
    if (top > 50) {
      $("body").addClass("sticky");
    } else {
      $("body").removeClass("sticky");
    }
  });
  /*$(".site-search").magnificPopup({
    type: "inline",
    preloader: false,
  });*/
  
  $(document).on('click', '.site-search', function(e){
    e.preventDefault();
    $('html').addClass('search-open');
  });
  $(document).on('click', '.search-close', function(e){
    e.preventDefault();
    $('html').removeClass('search-open');
  });
  $(".menu-item-image").first().addClass("active");
  $(".header-menu > li> a").on("mouseover", function () {
    var targetIndex = $(this).attr("data-target");
    $(".menu-item-image").removeClass("active");
    $('.menu-item-image[data-target="' + targetIndex + '"]').addClass("active");
  });
  $(".header-menu > li> a").on("mouseout", function () {
    $(".menu-item-image").removeClass("active");
    $(".menu-item-image").first().addClass("active");
  });

  var $slider = $(".counter-cl"),
    $prevArrow = $(".sl-icon-lt"),
    $nextArrow = $(".sl-icon-rt");

  $slider.slick({
    rows: 3,
    dots: false,
    infinite: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          rows: 3,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  function updateArrows(slick, currentSlide) {
    $prevArrow.toggleClass("disabled", currentSlide === 0);
    $nextArrow.toggleClass(
      "disabled",
      currentSlide + slick.options.slidesToShow >= slick.slideCount
    );
  }
  $slider.on("init reInit afterChange", function (event, slick, currentSlide) {
    updateArrows(slick, currentSlide);
  });

  $prevArrow.on("click", () => $slider.slick("slickPrev"));
  $nextArrow.on("click", () => $slider.slick("slickNext"));

  $(".jsCounter").each(function () {
    let targetValue = parseFloat($(this).text());

    $(this)
      .prop("Counter", 0)
      .animate(
        { Counter: targetValue },
        {
          duration: 4000,
          easing: "swing",
          step: function (now) {
            let formattedNumber;
            if (targetValue % 1 === 0) {
              formattedNumber = Math.floor(now).toLocaleString("en");
            } else {
              formattedNumber = now.toLocaleString("en", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              });
            }
            $(this).text(formattedNumber);
          },
        }
      );
  });
  // $(".hm-news-img-in").first().addClass("active");
  $(".hm-news-cnt").on("mouseover", function () {
    var targetIndex = $(this).attr("data-target");
    $(".hm-news-img-in").removeClass("active");
    $('.hm-news-img-in[data-target="' + targetIndex + '"]').addClass("active");
}).on("mouseout", function () {
    $(".hm-news-img-in").removeClass("active");
});

  if ($(".works-cl").length > 0) {
    var $projectslider = $(".works-cl"),
      $prev = $(".hm-work .sl-click-lt"),
      $next = $(".hm-work .sl-click-rt"),
      $slideCounter = $(".slide-counter");
    $projectslider.slick({
      dots: false,
      infinite: true,
      arrows: false,
      fade: true,
      pauseOnHover: false,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

    function updateArrows(slick, currentSlide) {
      $prev.toggleClass("disabled", currentSlide === 0);
      $next.toggleClass(
        "disabled",
        currentSlide + slick.options.slidesToShow >= slick.slideCount
      );
    }
    function updateSlideCounter(currentSlide, totalSlides) {
      $slideCounter.text(`${currentSlide + 1}/${totalSlides}`);
    }
    $projectslider.on(
      "init reInit afterChange",
      function (event, slick, currentSlide) {
        currentSlide = currentSlide || 0;
        updateArrows(slick, currentSlide);
        $(".pro-lists-img").removeClass("active");
        updateSlideCounter(currentSlide, slick.slideCount);
        startProgress(3);
      }
    );

    $projectslider.on("init", function () {
      updateSlideCounter(0, $projectslider.slick("getSlick").slideCount);
    });

    $prev.on("click", () => $projectslider.slick("slickPrev"));
    $next.on("click", () => $projectslider.slick("slickNext"));
    updateSlideCounter(0, $projectslider.slick("getSlick").slideCount);

    $prev.on("click", () => {
      $projectslider.slick("slickPrev");
    });

    $next.on("click", () => {
      $projectslider.slick("slickNext");
    });
    startProgress(3);
  }

  function startProgress(duration) {
    let circle = document.getElementById("progress--circle");
    circle.style.strokeDashoffset = 18;
    circle.style.transition = "none";

    setTimeout(() => {
      circle.style.transition = " stroke-dashoffset " + duration + "s linear";
      circle.style.strokeDashoffset = "0"; // Animate from full to empty
    }, 100); // Small delay to ensure the transition is applied
  }
  AOS.init({
    easing: "ease-in-out-sine",
    duration: 400,
    once: true,
  });
  // function initGSAPAnimation() {
  //   var imagesToAnimate = $(".anim-img-wrap");
  //   if (imagesToAnimate?.length) {
  //     imagesToAnimate?.map(function (index, item) {
  //       let tl = gsap.timeline({
  //         scrollTrigger: {
  //           trigger: item,
  //           start: "top 80%",
  //         },
  //       });
  //       tl.addLabel("start")
  //         .to(
  //           $(item).find(".anim-img-wrap-in"),
  //           {
  //             clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
  //             duration: 1.4,
  //             height: "100%",
  //             ease: "sine.out",
  //             delay: 0.2,
  //           },
  //           "start"
  //         )
  //         .fromTo(
  //           $(item).find("img"),
  //           {
  //             scale: 1.1,
  //           },
  //           {
  //             scrollTrigger: item,
  //             scale: 1,
  //             duration: 1.6,
  //             ease: "sine.out",
  //             delay: 0.2,
  //           },
  //           "start"
  //         );
  //     });
  //   }
  // }
  // initGSAPAnimation();
  $(".heading-text").lettering();
  const tl = gsap.timeline({});
  tl.add("start")
    // .fromTo(
    //   ".img-wrapper",
    //   {
    //     y: $WindowHeight - $WindowHeight / 3,
    //     clipPath: "polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)",
    //   },
    //   {
    //     y: 0,
    //     clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    //     duration: 1,
    //     ease: "sine.out",
    //   },
    //   "start"
    // )
    // .fromTo(
    //   ".hm-banner img",
    //   {
    //     scale: 1.7,
    //   },
    //   {
    //     scale: 1,
    //     duration: 1,
    //     ease: "power4.out",
    //   },
    //   "start"
    // )
    .fromTo(
      ".heading-text span",
      {
        y: 100,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.03,
        delay: 0.2,
        duration: 1,
      },
      "start"
    );
  $(".newsroomform").on("change", function () {
    $(this).submit();
  });
  $(".projectchildform").on("change", function () {
    loadpost($(this));
  });

  function loadpost(that) {
    var $url = that.attr("action");
    var $tgt = "#projects-container";
    var $eduLevel = $('input[name="edu-level"]:checked').val();

    var $location = $('input[name="loc[]"]:checked')
      .map(function () {
        return $(this).val();
      })
      .get(); // Convert to array

    $("#projects-container").addClass("loading");

    // var $serializedData = $.param({
    //   "loc[]": $location, // Keep as an array
    //   "edu-level": $eduLevel,
    // });

    // var nextURL = $url + "?" + $serializedData;



    var data = {
      "loc[]": $location // Keep as an array
    };

    // Check if $eduLevel is not undefined or empty
    if ($eduLevel) {
      data["edu-level"] = $eduLevel;
    }

    var $serializedData = $.param(data);
    var nextURL = $url + "?" + $serializedData;

    history.pushState(null, "", nextURL);

    $($tgt).load(nextURL + " " + $tgt, function () {
      $("#projects-container").removeClass("loading");
      AOS.init({
        easing: "ease-in-out-sine",
        duration: 400,
        once: true,
      });
    });
  }
  $(document).on("change", ".term-locations input", function () {
    if ($(this).is("#loc0")) {
      $(".term-locations input").not(this).prop("checked", false);
    } else {
      $("#loc0").prop("checked", false);
    }

    // Trigger form submission only when #loc0 is checked
    if ($("#loc0").is(":checked")) {
      $(".filters-lists form").trigger("change");
    }
  });
  $(document).on("click", "#reset-filters", function () {
    const newUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newUrl);
    $(".filters-lists form")[0].reset();
    loadpost($(".filters-lists form"));
  });

  $(document).on("click", ".loadmore", function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data("target"),
      link = $el.attr("href");
    if ($el.attr("disabled")) return;
    $el.addClass("loading").attr("disabled", true);
    $el.find("span").html("Loading...");
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents(".load-more").removeAttr("disabled").remove();
        AOS.init({
        easing: "ease-in-out-sine",
        duration: 400,
        once: true,
      });
    });

  });

  $(document).on("click", ".filters-toggle", function () {
    $(".filters-toggle").toggleClass("active");
    $(".filters-lists").toggleClass("active");
    // $('.filters-lists').slideToggle();
  });

  $(document).on("click", ".sp-project-info-toggle", function () {
    $(".sp-project-info-cnt").slideToggle("slow");
    $(this).toggleClass("active");
  });

  $(".sp-images-item").magnificPopup({
    type: "image",
    closeBtnInside: false,
    fixedContentPos: true,
    gallery: {
      enabled: true,
    },
    mainClass: "mfp-fade",
    removalDelay: 300,
  });

  function initializeSlick() {
    if ($(window).width() < 768) {
      if (!$(".sp-related-project-in").hasClass("slick-initialized")) {

        var $sp_slider = $(".sp-related-project-in"),
          $sp_prevArrow = $(".sl-icon-lt"),
          $sp_nextArrow = $(".sl-icon-rt");
        $sp_slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          autoplay: false,
          adaptiveHeight: true,
        });

        function updateArrows(slick, currentSlide) {
          $sp_prevArrow.toggleClass("disabled", currentSlide === 0);
          $sp_nextArrow.toggleClass(
            "disabled",
            currentSlide + slick.options.slidesToShow >= slick.slideCount
          );
        }
        $sp_slider.on("init reInit afterChange", function (event, slick, currentSlide) {
          updateArrows(slick, currentSlide);
        });

        $sp_prevArrow.on("click", () => $sp_slider.slick("slickPrev"));
        $sp_nextArrow.on("click", () => $sp_slider.slick("slickNext"));
      }

      if (!$(".related-posts-cnt").hasClass("slick-initialized")) {
        var $slider = $(".related-posts-cnt"),
          $prevArrow = $(".sl-icon-lt"),
          $nextArrow = $(".sl-icon-rt");
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          autoplay: false,
          adaptiveHeight: true,
        });

        function updateArrows(slick, currentSlide) {
          $prevArrow.toggleClass("disabled", currentSlide === 0);
          $nextArrow.toggleClass(
            "disabled",
            currentSlide + slick.options.slidesToShow >= slick.slideCount
          );
        }
        $slider.on(
          "init reInit afterChange",
          function (event, slick, currentSlide) {
            updateArrows(slick, currentSlide);
          }
        );

        $prevArrow.on("click", () => $slider.slick("slickPrev"));
        $nextArrow.on("click", () => $slider.slick("slickNext"));
        $(".related-posts-head-all").addClass("btn"); // adding button class to all posts
      }
    } else {
      if ($(".sp-related-project-in").hasClass("slick-initialized")) {
        $(".sp-related-project-in").slick("unslick"); // Destroy Slick on desktop
      }
      if ($(".related-posts-cnt").hasClass("slick-initialized")) {
        $(".related-posts-cnt").slick("unslick"); // Destroy Slick on desktop
        $(".related-posts-head-all").removeClass("btn");
      }
    }
  }

  // Run on page load
  initializeSlick();

  // Re-initialize on window resize
  $(window).on("resize", function () {
    initializeSlick();
  });
  var $hst_slider = $(".history-cl"),
    $hst_prevArrow = $(".abt-history .sl-icon-lt"),
    $hst_nextArrow = $(".abt-history .sl-icon-rt");
  $hst_slider.slick({
    dots: false,
    infinite: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  function Hstupdatearrows(slick, currentSlide) {
    $hst_prevArrow.toggleClass("disabled", currentSlide === 0);
    $hst_nextArrow.toggleClass(
      "disabled",
      currentSlide + slick.options.slidesToShow >= slick.slideCount
    );
  }
  $hst_slider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide) {
      Hstupdatearrows(slick, currentSlide);
    }
  );

  $hst_prevArrow.on("click", () => $hst_slider.slick("slickPrev"));
  $hst_nextArrow.on("click", () => $hst_slider.slick("slickNext"));

  function teamslider() {
    var $tm_slider = $(".team-cl"),
      $tm_prevArrow = $(".abt-team .sl-icon-lt"),
      $tm_nextArrow = $(".abt-team .sl-icon-rt");
    $tm_slider.slick({
      dots: false,
      infinite: false,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    function tmupdatearrows(slick, currentSlide) {
      $tm_prevArrow.toggleClass("disabled", currentSlide === 0);
      $tm_nextArrow.toggleClass(
        "disabled",
        currentSlide + slick.options.slidesToShow >= slick.slideCount
      );
    }
    $tm_slider.on(
      "init reInit afterChange",
      function (event, slick, currentSlide) {
        tmupdatearrows(slick, currentSlide);
      }
    );
    $tm_prevArrow.on("click", () => $tm_slider.slick("slickPrev"));
    $tm_nextArrow.on("click", () => $tm_slider.slick("slickNext"));
  }

  teamslider();

  $(document).on("click", ".post-category", function (e) {
    e.preventDefault();
    // $("#preloader").fadeIn();
    $(".post-category").removeClass("active");
    $(this).addClass("active");
    var $tgt = "#blog-container";
    var newUrl = $(this).attr("href");
    $("<div>").load(newUrl, function () {
      $($tgt).html($(this).find($tgt).html());

      teamslider();
      teampopup();
      // $("#preloader").fadeOut();
    });
  });

  $(document).on("mousemove", ".e-featured", function (e) {
    $("#hover-tail").css({
      left: e.pageX + 20 + "px",
      top: e.pageY + "px",
    });
  });
  function teampopup() {
    /*$(".popup-team").magnificPopup({
      type: "inline",
      preloader: false,
      closeOnContentClick: false,
      loseBtnInside: true,
      mainClass: "mfp-tm-popup",
    });*/
    $(document).on("click", ".team-member", function () {
      var tgt = $(this).data("href");
      $(tgt)[0].click();
    });
    $(document).on('click', '.popup-team', function(e){
      e.preventDefault();
      var tgt = $(this).attr("href");
      $('.team-popup').removeClass('active');
      $(tgt).addClass('active');
      $('html').addClass('team-modal-open');
    });
    
    $(document).on('click', '.popup-close', function(e){
      e.preventDefault();
      $('.team-popup').removeClass('active');
      $('html').removeClass('team-modal-open');
    });
     $(document).on('click', '.team-popup', function (e) {
      // Check if the clicked element is not inside the .slide-popup-in
      if (!$(e.target).closest('.team-popup-wrap').length) {
        $('html').removeClass('team-modal-open');
        $(this).removeClass('active');
      }
    });
    // $(document).on("click", ".team-member li a", function (e) {
    //   e.stopPropagation();
    // });
  }

  teampopup();
  $(window).on("resize", function () {
    teampopup();
  });
  function toggleMenu() {
    // $(".toggle-item").hide();
    $(document).on("click", ".at-toggle", function () {
      $(".toggle-item").slideToggle();
      $(this).toggleClass("active");
    });
  }
  toggleMenu();
  var $se_slider = $(".se-related-cl"),
    $se_prevArrow = $(".se-related .sl-icon-lt"),
    $se_nextArrow = $(".se-related .sl-icon-rt");
  $se_slider.slick({
    dots: false,
    infinite: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  function tmupdatearrows(slick, currentSlide) {
    $se_prevArrow.toggleClass("disabled", currentSlide === 0);
    $se_nextArrow.toggleClass(
      "disabled",
      currentSlide + slick.options.slidesToShow >= slick.slideCount
    );
  }
  $se_slider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide) {
      tmupdatearrows(slick, currentSlide);
    }
  );
  $se_prevArrow.on("click", () => $se_slider.slick("slickPrev"));
  $se_nextArrow.on("click", () => $se_slider.slick("slickNext"));

  $(document).on("click", ".accn-tab-hd", function (e) {
    $(".accn-tab").removeClass("active");
    $(".accn-tab-cnt").slideUp("normal");
    if ($(this).next().is(":hidden") == true) {
      $(this).parent().addClass("active");
      $(this).next().slideDown("normal");
    }
  });

  $(".review-cl").slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  var $pro_slider = $(".career-cl"),
    $pro_prevArrow = $(".careerlf-features .sl-icon-lt"),
    $pro_nextArrow = $(".careerlf-features .sl-icon-rt");
  $pro_slider.slick({
    dots: false,
    infinite: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  function tmupdatearrows(slick, currentSlide) {
    $pro_prevArrow.toggleClass("disabled", currentSlide === 0);
    $pro_nextArrow.toggleClass(
      "disabled",
      currentSlide + slick.options.slidesToShow >= slick.slideCount
    );
  }
  $pro_slider.on(
    "init reInit afterChange",
    function (event, slick, currentSlide) {
      tmupdatearrows(slick, currentSlide);
    }
  );
  $pro_prevArrow.on("click", () => $pro_slider.slick("slickPrev"));
  $pro_nextArrow.on("click", () => $pro_slider.slick("slickNext"));

  $(".career-vdo").magnificPopup({
    type: "iframe",
    closeBtnInside: false,
    mainClass: "mfp-vdo",
    // preloader: false,
    // fixedContentPos: false,
  });
  $(document).on("mousemove", ".careercd-vdo", function (e) {
    $("#hover-tail").css({
      left: e.pageX + 20 + "px",
      top: e.pageY + "px",
    });
  });

  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $("header").outerHeight();

  $(window).on("scroll", function () {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }

    // console.log(st, lastScrollTop, navbarHeight);
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $("header").removeClass("nav-down").addClass("nav-up");
    } else {
      if (st < navbarHeight) {
        if (st === 0 || st < 50) {
          $("header").css("position", "fixed");
        }
      } else {
        $("header").css("position", "fixed");
      }
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $("header").removeClass("nav-up").addClass("nav-down");
      }
    }
    lastScrollTop = st;
  }
  // Copy Link Js
  $(document).on("click", ".copyclip", function (e) {
    e.preventDefault();
    var textToCopy = $(this).data("text");
    var tempTextarea = $("<textarea>");
    $("body").append(tempTextarea);
    tempTextarea.val(textToCopy).select();
    document.execCommand("copy");
    tempTextarea.remove();
    $(this).text("Copied");
  });

  $(".location-item").hover(
    function () {
      var loc = $(this).data("loc");
      $(".location-item").removeClass("active");
      $(this).addClass("active");
      $(".map-loc-icon").removeClass("active");
      $(".map-loc-icon[data-loc='" + loc + "']").addClass("active");
    },
    function () {
      var loc = $(this).data("loc");
      $(this).removeClass("active");
      $(".location-item").addClass("active");
      $(".map-loc-icon").addClass("active");
      $(".map-loc-icon[data-loc='" + loc + "']").addClass("active");
    }
  );

  $(document).on('click', '.copyclip', function (e) {
    e.preventDefault();
    var textToCopy = $(this).data('text');
    var tempTextarea = $('<textarea>');
    $('body').append(tempTextarea);
    tempTextarea.val(textToCopy).select();
    document.execCommand('copy');
    tempTextarea.remove();
    $(this).text('Copied');
  });
});
